import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Text = styled.div`
	color: black;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;

	${({ disabled }) => disabled && `color: ${colors.grey4}`};
`;

export const CellText = styled.div`
	color: ${colors.grey5};
	text-align: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	width: 100%;
`;

export const InputText = styled(CellText)`
	display: flex;
	justify-content: center;
	color: ${colors.grey5};
	text-align: right;
	padding-right: 6px;
`;

export const EditInput = styled.input`
	all: unset;
	color: ${colors.grey8};
	font-weight: 500;
	font-size: 13px;
	width: 100%;
`;

export const TooltipContent = styled.div`
	text-align: left;
`;

export const IconWrapper = styled.div`
	height: 16px;
	padding: 0 9px;
	margin-left: auto;
`;
